/**
 * 画面ごとのURLの定義
 */
export const PAGE_PATH: PagePathProps = {
  START: '/',
  TROUBLE_PLACE: '/trouble-place',
  TROUBLE_PLACE_SURROUNDING: '/trouble-place/surrounding',
  VEHICLE_STATE: '/trouble-place/info/vehicle-state',
  ENGINE_TROUBLE: '/trouble-place/info/vehicle-state/engine-trouble',
  FLAT_TIRE: '/trouble-place/info/vehicle-state/flat-tire',
  ACCIDENT: '/trouble-place/info/vehicle-state/accident',
  FALLING_WHEEL: '/trouble-place/info/vehicle-state/falling-wheel',
  EMPTY_FUEL: '/trouble-place/info/vehicle-state/empty-fuel',
  LOSS_KEY: '/trouble-place/info/vehicle-state/loss-key',
  OTHERS: '/trouble-place/info/vehicle-state/others',
  TRANSPORT_DESTINATION:
    '/trouble-place/info/vehicle-state/transport-destination',
  SERVICE_OTHER_EMPTY: '/service-other-empty',
  SERVICE_EMPTY: '/service-empty',
  CONFIRMATION: '/confirmation',
  INFORMED: '/informed',
  ASSIGNED: '/assigned',
  LOCATION_SHARING: '/location-sharing',
  JOINED: '/joined',
  NO_GUIDE: '/no-guide',
  RE_ASSIGNED: '/re-assigned',
  IMPASSE: '/impasse',
  CANCELED: '/canceled',
  ERROR: '/error',
  CLOSED: '/closed',
  SPECIAL_CONTRACT: '/special-contract',
  RESERVATION: '/reservation',
  RESERVED: '/reserved',
  SERVICE_INFORMATION: '/service-information',
  CONTRACT_INFORMATION: '/contract-information',
  RE_ACCESS: '/re-access',
}

/**
 * 型定義：URL定義
 */
type PagePathProps = {
  [PAGE: string]: string
}
